import { createContext, useContext, useState, useCallback } from "react";
import { randomAvatar } from "@/lib/avatars";

const AppContext = createContext(null);

function persistentId() {
  let id = localStorage.getItem("lostdc_pid");
  if (!id) {
    id = "p_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("lostdc_pid", id);
  }
  return id;
}

export function AppProvider({ children }) {
  const [playerId] = useState(persistentId);
  const [username, setUsernameState] = useState(() => localStorage.getItem("lostdc_name") || "");
  const [avatar, setAvatarState] = useState(() => localStorage.getItem("lostdc_avatar") || randomAvatar());

  const setUsername = useCallback((n) => {
    setUsernameState(n);
    localStorage.setItem("lostdc_name", n);
  }, []);
  const setAvatar = useCallback((a) => {
    setAvatarState(a);
    localStorage.setItem("lostdc_avatar", a);
  }, []);

  return (
    <AppContext.Provider value={{ playerId, username, setUsername, avatar, setAvatar }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  return useContext(AppContext);
}
